import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/PageLayout/index.ts";
export const data = {
  title: "Projects",
  subtitle: ""
};
export const _frontmatter = {};
const layoutProps = {
  data,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Stakeholder management chat app`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://stakeholder-management.netlify.app/"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Loss Control Questionaire app`}</h2>
    <ul>
      <li parentName="ul">{`Angular`}</li>
      <li parentName="ul">{`Material UI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://loss-control-app.netlify.app/"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Jumpster`}</h2>
    <p>{`Prototype for social networking site to join and create events.`}</p>
    <ul>
      <li parentName="ul">{`React`}</li>
      <li parentName="ul">{`Bootstrap`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leecheuk.github.io/jumpster"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`PJs`}</h2>
    <p>{`A startup mockup for a website of property rentals.`}</p>
    <ul>
      <li parentName="ul">{`React`}</li>
      <li parentName="ul">{`Bootstrap`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leecheuk.github.io/pjs"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`leecheuk.github.io`}</h2>
    <p>{`Old portfolio page created by Jekyll. This showcases old projects for single page applications (SPA) using react or vue.`}</p>
    <ul>
      <li parentName="ul">{`jekyll`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leecheuk.github.io"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Visual lime`}</h2>
    <p>{`A code editor app.`}</p>
    <ul>
      <li parentName="ul">{`VueJS`}</li>
      <li parentName="ul">{`Bootstrap`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leecheuk.github.io/editor"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Ereader-themed text editor`}</h2>
    <p>{`An ereader-themed text editor.`}</p>
    <ul>
      <li parentName="ul">{`VueJS`}</li>
      <li parentName="ul">{`Bootstrap`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://leecheuk.github.io/ereader"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Lotto - Generate & Save lotto#`}</h2>
    <p>{`"Having trouble deciding what lotto numbers to pick? Want to save you favourite lotto numbers? Our app Lotto can save lotto numbers, generate lotto numbers randomly, based on number of odd or even numbers and the number of single digit numbers." I did not continue the developer membership, so it is now not in app store.`}</p>
    <ul>
      <li parentName="ul">{`React Native`}</li>
      <li parentName="ul">{`Realm`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://appadvice.com/app/lotto-generate-save-lotto/1335752594"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Mottos`}</h2>
    <p>{`"Mottos is for reading mottos or quotes daily. Remind and inspire yourself to become who you are meant to be. Change your lifestyle, develop habits through reading your mottos daily. Mottos lets you save your mottos/quotes, read them distraction free, set daily or hourly unreads!" I did not continue the developer membership, so it is now not in app store.`}</p>
    <ul>
      <li parentName="ul">{`React Native`}</li>
      <li parentName="ul">{`Realm`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://appadvice.com/app/mottos/1328607444"
        }}>{`demo`}</a></li>
    </ul>
    <h2>{`Pick - Decide for you`}</h2>
    <p>{`"Cannot decide amongst a set of options? Don't want to waste time on deciding, like what to eat? Wanna make a random pick? Pick allows you to add a list of options you need to pick from and it picks one for you! You can save lists of options so you can quickly pick from the options." I did not continue the developer membership, so it is now not in app store.`}</p>
    <ul>
      <li parentName="ul">{`React Native`}</li>
      <li parentName="ul">{`Realm`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://appadvice.com/app/pick-decide-for-you/1332929922"
        }}>{`demo`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      